import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Table, Button, Select } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import CarIcon from '@assets/icons/CarSvg'
import ViewIcon from '@assets/icons/viewSvg'
import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import { fetchPurchasesIncoming } from '@utils/fetchData'
import { handleNavigateCarInvoices } from '@utils/navigateToPdf'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

import CreteLandedCostsModal from '../createLandedCostsModal'
import InvoiceVendorPaymentModal from '../invoiceVendorPaymentModal'



import ViewDetailedPurchaseIncomingModal from './detailedPurchaseIncoming'
import PurchaseIncomingTab from './PurchaseIncomingModal'


const PurchaseIncomingModal = ({
	data,
	finishSale = false,
	ship = false,
	changeStatus = false,
	showPayment = false,
	isShowLandedCosts = false,
	isShowLandedCostTab = false,
	refetch,
	onClose,
}) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const roleNames = useSelector((state) => state.main.roleNames)
	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)

	const [dueDate, setDueDate] = useState('')
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [status, setStatus] = useState('')
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [dopZatrataModal, setDopZatrataModal] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const {
		data: purchaseIncomingData = [],
		isLoading: loadingPurchaseIncoming,
		refetch: loadingPurchaseIncomingRefetch,
	} = useQuery({
		queryKey: ['purchaseIncoming', data?.docEntry],
		queryFn: fetchPurchasesIncoming,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!data?.docEntry,
	})

	const handleButtonClick = () => {
		setIsModalVisible(true)
	}

	const handleModalYes = () => {
		setDopZatrataModal(true)
		setIsModalVisible(false)
	}

	const handleModalNo = () => {
		finishSalePost()
		setIsModalVisible(false)
	}

	const onView = (record) => {
		setSelectedRowData(record)
		setIsViewModalVisible(true)
	}

	const handleModalCancel = () => {
		setIsModalVisible(false)
	}
	useEffect(() => {
		if (data?.docDueDate) {
			let date = ''
			;(finishSale && roleNames.includes('Supplier')) ||
			roleNames.includes('admin')
				? (date = moment().format('YYYY-MM-DD'))
				: (date = moment(data?.docDueDate).format('YYYY-MM-DD'))
			setDueDate(date)
			console.log(date)
		}
		if (data?.u_Status) {
			setStatus(data.u_Status)
		}
		console.log('Data  = ', data)
	}, [data])

	const finishSalePost = async () => {
		setShipBtnLoading(true)

		const documentLines = purchaseIncomingData
			.map((line) => line.documentLines)
			.flat()
			.map((item, idx) => {
				return {
					baseEntry: item.docEntry,
					baseLine: item.lineNum,
					itemCode: item.itemCode,
					quantity: item.quantity,
					price: item.price,
					currency: item.currency,
					warehouseCode: item.warehouseCode,
					u_Kvmetr: (item.quantity / item.kvmetr).toFixed(2),
				}
			})

		const postingData = {
			cardCode: purchaseIncomingData[0]?.cardCode,
			documentsOwner: employeeId,
			salesPersonCode: salesPersonCode,
			docDueDate: dueDate,
			docDate: dueDate,
			comments: purchaseIncomingData[0]?.comments,
			docCurrency: purchaseIncomingData[0]?.docCurrency,
			u_FuraNum: purchaseIncomingData[0]?.u_FuraNum,
			u_InvoiceNum: purchaseIncomingData[0]?.docNum,
			documentLines,
		}

		try {
			await http.post(
				`api/purchase/haridni-yakunlash/${data?.docEntry}`,
				postingData,
			)
			onClose()
			refetch()
			successRef.current?.open(t('sucCreation'))
		} catch (error) {
			console.log(error)
			errorRef.current?.open(error?.response?.data?.message)
		} finally {
			setShipBtnLoading(false)
		}
	}

	if (!data) return null

	const tableData = data?.documentLines.map((item, index) => ({
		...item,
		key: index,
		itemDescription: item.itemDescription,
		quantity: item.quantity,
		price: item.price,
		lineTotal: item.lineTotal,
		whsName: item.whsName,
		ugpCode: item.ugpCode,
		docNum: item.docNum,
		docEntry: item.docEntry,
		currency: item.currency,
	}))

	const columnsP = [
		{
			title: t('numZakaz'),
			dataIndex: 'docNumPrefix',
			key: 'docNumPrefix',
			text: 'center',
		},

		{
			title: t('date'),
			dataIndex: 'docDate',
			key: 'docDate',
			text: 'center',
			render: (text) => {
				const formattedText = moment(text, 'DD.MM.YYYY', true).isValid()
					? text
					: moment(text).format('DD.MM.YYYY')
				return `${formattedText}`
			},
		},

		{
			title: t('supplier'),
			dataIndex: 'cardName',
			key: 'cardName',
			text: 'center',
		},

		{
			title: t('docTotal'),
			dataIndex: 'docTotal',
			key: 'docTotal',
			text: 'center',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return `${formattedText} ${record?.docCurrency}`
			},
		},

		// {
		// 	title: t('landedCost'),
		// 	dataIndex: 'costSum',
		// 	key: 'costSum',
		// 	text: 'center',
		// 	render: (text, record) => {
		// 		return `${text > 0 ? `${numberWithSpacesIntl(text)} ` : '-'} `
		// 	},
		// },
		{
			title: t('status'),
			dataIndex: 'u_Status',
			key: 'u_Status',
			text: 'center',
			render: (text, record) => <span>{t(`${text}`)}</span>,
		},

		{
			title: '',
			dataIndex: 'action',
			key: 'action',
			width: 120,
			text: 'center',
			render: (text, record) => (
				<div className="flex items-center gap-2">
					<button
						onClick={() => onView(record)}
						className="bg-[#2198c7] text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
					>
						<ViewIcon />
					</button>
					<button
						onClick={() =>
							handleNavigateCarInvoices(
								record,
								data?.docNumPrefix,
							)
						}
						className="bg-green-500 text-white w-[35px] h-[30px] rounded-lg flex justify-center items-center"
					>
						<CarIcon />
					</button>
				</div>
			),
		},
	]

	return (
		<div className="w-full px-4 sm:px-14">
			<div className="w-full">
				<Table
					columns={columnsP}
					dataSource={purchaseIncomingData}
					pagination={false}
					className="border-1 mt-12 border-black"
					scroll={{ x: '100%' }}
					bordered
				/>

				<div className="w-full flex items-center justify-end mt-10  ">
					<>
						{/* <div className="flex gap-5">
							{finishSale ? (
								<Button
									onClick={handleButtonClick}
									loading={shipBtnLoading}
									className="h-[30px] bg-[#0A4D68] rounded-lg text-white"
								>
									{t('finishInvoice')}
								</Button>
							) : (
								''
							)}
						</div> */}
						{/* <Modal
							open={isModalVisible}
							onCancel={handleModalCancel}
							footer={null}
						>
							<div className="flex flex-col items-center justify-between m-5">
								<p className="font-bold text-lg">
									{t('haveYouGotDopZatrata')}
								</p>

								<div className="flex items-center gap-5 mt-5">
									<Button
										className="bg-red-600 text-white"
										key="no"
										onClick={handleModalNo}
									>
										{t('no')}
									</Button>

									<Button
										key="yes"
										className="bg-[#0A4D68] text-white"
										onClick={() => {
											setDopZatrataModal(true)
											setIsModalVisible(false)
										}}
									>
										{t('yes')}
									</Button>
								</div>
							</div>
						</Modal> */}
					</>
				</div>
			</div>
			<InvoiceVendorPaymentModal
				visible={isPaymentModalVisible}
				onClose={() => setIsPaymentModalVisible(false)}
				data={data}
			/>
			<CreteLandedCostsModal
				visible={dopZatrataModal}
				data={data}
				docDate={dueDate}
				onClose2={() => {
					setDopZatrataModal(false)
				}}
				finishSalePost={finishSalePost}
				refetch={() => refetch()}
			/>
			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<PurchaseIncomingTab
				data={selectedRowData}
				onClose={() => {
					setIsViewModalVisible(false)
				}}
				isShowLandedCostTab={isShowLandedCostTab}
				isShowLandedCosts={isShowLandedCosts}
				visible={isViewModalVisible}
				refetch={loadingPurchaseIncomingRefetch}
			/>
		</div>
	)
}

export default PurchaseIncomingModal
